import { render, staticRenderFns } from "./profilku.vue?vue&type=template&id=9c9b8cc0&"
import script from "./profilku.vue?vue&type=script&lang=js&"
export * from "./profilku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports